import React from 'react';

function NextLocation() {

    

    return (
        <section className="section">
            
            <div>
            <div className="video"><iframe title="Decades 2022" className="video__i-frame" src="https://player.vimeo.com/video/702549278?h=3e2bdc6c21" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture"></iframe></div>     
            <p className="fine-print fine-print--center">{/*This is where the credits will go for video and music.*/}Additional footage from <a href="https://www.pexels.com/" target="_blank" rel="noreferrer">Pexels</a> from contributers <a href="https://www.pexels.com/video/the-sunset-view-captured-by-a-drone-camera-4563312/" target="_blank" rel="noreferrer">Motion Media</a>, <a href="https://www.pexels.com/video/close-up-of-a-static-television-8546323/" target="_blank" rel="noreferrer">Valiantsin Konan</a>, <a href="https://www.pexels.com/video/aerial-footage-of-a-town-in-iceland-9881117/" target="_blank" rel="noreferrer">Gylfi Gylfason</a>, and <a href="https://www.pexels.com/video/drone-footage-of-the-trees-canopy-of-a-thick-forest-2491285/" target="_blank" rel="noreferrer">Kelly L</a>.</p>
            <p className="fine-print fine-print--center">Music from <a href="https://artlist.io/" target="_blank" rel="noreferrer">Artlist from contributers kutiman and tristan-barton</a>.</p>        
            </div>
            
        </section>
    );
}

export default NextLocation;